import { initializeWebTracking } from '@hqo/web-tracking';
import { setUser as setSentryUser } from '@sentry/browser';
import { useEffect } from 'react';
import { TRACKING_APP } from 'app/shared/consts/tracking';
import { useApi } from 'app/shared/contexts/api';
import { useBuilding } from 'app/shared/contexts/building';
import { useSentryAnalytics } from 'app/shared/hooks/use-sentry-analytics';
import { useUser } from 'app/shared/contexts/user';

export const useAnalytics = (): void => {
  const analytics = useSentryAnalytics();
  const { building } = useBuilding();
  const { user } = useUser();
  const { apiUrl, getAuthToken } = useApi();

  useEffect(() => {
    // Skip the null pass — Sentry treats setUser(null) as "clear user" and we'd
    // otherwise strip user context every boot while building/user are loading.
    if (analytics) {
      // Sentry only indexes a top-level `id` as the searchable user id; without it the uuid stays
      // buried in `visitor` and `user.id:<uuid>` matches nothing.
      setSentryUser({ ...analytics, id: analytics.visitor?.id });
    }
  }, [analytics]);

  useEffect(() => {
    if (!building || !user) {
      return;
    }
    initializeWebTracking(
      getAuthToken,
      building.uuid,
      TRACKING_APP,
      navigator?.userAgent,
      apiUrl,
    );
  }, [building, user, apiUrl, getAuthToken]);
};
